import PropTypes from 'prop-types';
import React from 'react';
import ReactTooltip from 'react-tooltip';

import './styles/tooltip.scss';

const Tooltip = (props) => (
  <div className={`tooltip-component ${props.className}`}>
    <span
      data-delay-hide={props.delayHide}
      data-delay-show={props.delayShow}
      data-effect={props.effect}
      data-event={`mouseenter ${props.clickable ? "focus click" : ""}`}
      data-event-off={`mouseleave ${props.clickable ? "keypress click" : ""}`}
      data-for={props.tooltipId}
      data-offset={props.offset}
      data-place={props.placement}
      data-tip=""
      role="presentation"
      tabIndex={props.clickable ? 0 : undefined}
    >
      {props.children}
    </span>
    <ReactTooltip clickable={props.clickable} id={props.tooltipId} type={props.type} >
      <span className="tooltip-red">
        {props.tooltipContent}
      </span>
    </ReactTooltip>
  </div>
);

export default Tooltip;

Tooltip.defaultProps = {
  className: '',
  clickable: false,
  delayHide: 0,
  delayShow: 0,
  effect: 'solid', // options: solid, float
  offset: null, // e.g. `{'left': 10}` (syntax is important here)
  placement: 'top',
  tooltipContent: '',
  tooltipId: '',
  type: 'dark', // options: dark, light
};

Tooltip.propTypes = {
  className: PropTypes.string,
  clickable: PropTypes.bool,
  delayShow: PropTypes.number,
  delayHide: PropTypes.number,
  effect: PropTypes.string,
  offset: PropTypes.string,
  placement: PropTypes.string,
  tooltipContent: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  tooltipId: PropTypes.string,
  type: PropTypes.string,
};
